import {JSX} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/destination-card.scss";

export type DestinationCardProps = {
    id: number | string;
    image?: {
        url: string;
        alt?: string;
    };
    title: string;
    url: string;
    imageSize?: {
        width: number;
        height: number;
    };
};

export function DestinationCard({image, title, url, imageSize = {width: 304, height: 421}}: DestinationCardProps): JSX.Element {
    const src = image?.url ?? assetPath("/images/placeholder-100.png");
    const alt = image?.alt ?? title;

    return (
        <article className="destination-card" aria-label={title}>
            <Link href={url} className="destination-card__link" aria-label={`Open ${title}`}>
                <SmartImage src={src} alt={alt} width={imageSize.width} height={imageSize.height} className="destination-card__image" />

                <div className="destination-card__name">
                    <Typography weight={600} as="h3" color="title" size={{desktop: 16, mobile: 12}} className="destination-card__name-title">
                        {title}
                    </Typography>

                    <SmartImage
                        src={assetPath("/images/icons/arrow-right.svg")}
                        alt="Arrow right"
                        width={24}
                        height={24}
                        className="destination-card__arrow"
                    />
                </div>
            </Link>
        </article>
    );
}
